import { createContext } from "react";

type SettingOrigin = 'permission-matrix-layout' | 'project-issue-level' | 'default-currency' | 'work-shifts';

interface SettingsContextValueType {
  handleCompanySettingChange: (origin: SettingOrigin, value: string) => void;
  permissionMatrixLayoutValue: string | null;
  projectIssueLevelValue: string | null;
  defaultCurrencyValue: string | null;
  defaultWorkShifts: string | null;
}

const SettingsContext = createContext<SettingsContextValueType>({
  handleCompanySettingChange: () => { },
  permissionMatrixLayoutValue: null,
  projectIssueLevelValue: null,
  defaultCurrencyValue: null,
  defaultWorkShifts: null,
});

export default SettingsContext
